import { render, staticRenderFns } from "./events.vue?vue&type=template&id=d79c84da&scoped=true&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"
import style0 from "./events.vue?vue&type=style&index=0&id=d79c84da&prod&scoped=true&lang=css&"
import style1 from "./events.vue?vue&type=style&index=1&id=d79c84da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79c84da",
  null
  
)

export default component.exports